import { JSX, useState } from "react";

import { EditAITextRequest, ID } from "@project/shared-types";
import { JobChangeAITextAPI } from "../../api/JobsAPI";
import AISvg from "../../assets/taiga-uikit/icons/ai.svg?react";
import MagicpenSvg from "../../assets/taiga-uikit/icons/magic-ai.svg?react";
import { _colorText, _sizeText } from "../../core/core";
import { Input } from "../inputs/Input";
import { Text } from "../texts/text";
import { TypingText } from "../TypingText/TypingText";

interface InputAIProps {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  job_id: ID;
  keywords?: string[];
  placeholder: string;
  labelOutside?: string | JSX.Element;
  [key: string]: any; // Allow additional props
}

export const InputAI: React.FC<InputAIProps> = ({
  job_id,
  value,
  setValue,
  keywords = [],
  placeholder,
  labelOutside,
  ...props
}) => {
  const [focus, setFocus] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchTask = async () => {
    try {
      setIsLoading(true);
      const response = await JobChangeAITextAPI({
        job_id: job_id,
        actual_text: value,
      } as EditAITextRequest);
      if (!response) return;
      setValue(response.text);
    } catch (error) {
      console.error("Ошибка при получении карточек услуг:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <TypingText
          texts={[
            "Получаем положительные отзывы...",
            "Генерируем текст отзыва...",
          ]}
        >
          <Text size={_sizeText.s} color={_colorText.black}></Text>
        </TypingText>
      ) : (
        <>
          <Input
            labelOutside={
              <>
                {labelOutside} <AISvg />
              </>
            }
            placeholder={placeholder}
            value={value}
            setValue={setValue}
            onFocus={() => setFocus(true)}
            onBlurHandel={() => setFocus(false)}
            {...props}
          />
          <div className={`input-dropdown-${focus}`}>
            <div onMouseDown={fetchTask} className="input-dropdown-item">
              <div className="input-dropdown-r">
                <MagicpenSvg />
              </div>
              <div className="input-dropdown-l">
                <Text size={_sizeText.s} color={_colorText.black}>
                  GPT Генератор текста
                </Text>
                <Text size={_sizeText.xs} color={_colorText.neutral}>
                  Создаёт текст на основе ваших отзывов, ключевых слов
                </Text>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
